import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import ViewPage from 'components/settings/Pages/ViewPage';
import CreateObject from 'components/settings/Pages/CreateObject';
import CreateRow from 'components/settings/Pages/CreateRow';
import CreateHtmlObject from 'components/settings/Pages/CreateHtmlObject';
import EditObject from 'components/settings/Pages/EditObject';
import EditHtmlObject from 'components/settings/Pages/EditHtmlObject';
import Pages from 'components/settings/Pages/Pages';
import EditRow from './EditRow';
import DeletePage from './DeletePage';
import FormObject from 'components/settings/Pages/FormObject';
import EditPage from 'components/settings/Pages/Edit';
import CreatePage from 'components/settings/Pages/Create';

const PagesContainer = () => {
    const match = useRouteMatch();
    //match.path = settings/pages

    return (
        <Switch>
            <Route path={`${match.path}/create`} exact component={CreatePage} />
            <Route path={`${match.path}/:id/edit`} exact component={EditPage} />
            <Route path={`${match.path}/:id/view`} exact component={ViewPage} />
            <Route
                path={`${match.path}/:id/delete`}
                exact
                component={DeletePage}
            />
            <Route
                path={`${match.path}/create-row/:id`}
                component={CreateRow}
            />
            <Route
                path={`${match.path}/rows/edit/:page/:row`}
                component={EditRow}
            />
            <Route
                path={`${match.path}/create-wysiwyg-object/:id/:row/:sortOrder`}
                component={CreateHtmlObject}
            />
            <Route
                path={`${match.path}/create-wysiwyg-object/:id`}
                component={CreateHtmlObject}
                exact
            />
            <Route
                path={`${match.path}/edit-wysiwyg-object/:page/:object`}
                component={EditHtmlObject}
            />
            <Route
                path={`${match.path}/create-object/:id`}
                component={CreateObject}
                exact
            />
            <Route
                path={`${match.path}/create-object/:id/:row/:sortOrder`}
                component={CreateObject}
            />
            <Route
                path={`${match.path}/form-object/:pageId/:rowId`}
                component={FormObject}
                exact
            />
            <Route
                path={`${match.path}/form-object/:pageId/:rowId/object/:objectId`}
                component={FormObject}
                exact
            />
            <Route
                path={`${match.path}/edit-object/:page/:object`}
                exact
                component={EditObject}
            />

            <Route path={`${match.path}/:id`} exact component={ViewPage} />
            <Route component={Pages} />
        </Switch>
    );
};

export default PagesContainer;
